import { Pagination, paginationToParams } from '../../Pagination';

export interface ExpiryReportFilter {
  pagination: Pagination;
}

export const getDefaultExpiryReportFilter = (): ExpiryReportFilter => ({
  pagination: { page: 0, pageSize: 10 },
});

export const expiryReportFilterToQueryParams = (filter: ExpiryReportFilter) =>
  paginationToParams(filter.pagination);
